<h1 mat-dialog-title>Rectifique el tópico asignado al siguiente texto</h1>
<div mat-dialog-content>
    <table>
        <tr>
            <td colspan="2" style="padding: 10px 0 10px 0;">{{data.text}}</td>
        </tr>
        <tr>
            <td style="width:150px; padding: 10px 0;">Tópico asignado</td>
            <td>{{data.topic}}</td>
        </tr>
        <tr>
            <td style="width:150px; padding: 0 0 20px 0;">Tópico rectificado</td>
            <td>
                <select title="topic-selector" [(ngModel)]="selectedTopic">
                    <option *ngFor="let topic of listOfTopics">
                        {{topic.name}}
                    </option>
                </select>
            </td>
        </tr>
    </table>
</div>
<div mat-dialog-actions>
    <button class="active:bg-blueGray-600 text-sm rounded shadow hover:shadow-lg p-1" mat-button
        (click)="onCancelClick()" style="margin: 0 30px 0 0;">Cancelar</button>
    <button class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm rounded shadow hover:shadow-lg p-1"
        mat-button (click)="onRectifyClick()">Rectificar</button>
</div>
